<script>
const authorize = function (appid) {
  if (!appid) {
    new Error('未传入APPID')
    return
  }
  let REDIRECT_URI = window.location.hash
  let origin = 'https://static.shecarefertility.com'
  let pathname = process.env.VUE_APP_MODE === 'development'? '/shecare/test/webview/': '/shecare/webview/'
  let authUrl = origin + pathname + '#/oauth'

  let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?'+
    'appid='+ appid +'&'+
    'redirect_uri='+ encodeURIComponent(authUrl) +'&'+
    'response_type=code&'+
    'scope=snsapi_userinfo&'+
    'state='+ encodeURIComponent(REDIRECT_URI) +'#wechat_redirect'

  window.open(url, '_self')
}

export default {
  init: authorize
}
</script>